<template>
  <div>
    <div class="personal" >
       <h3>
         信息认证
       </h3>
       
        <el-form 
        label-position="left"
        :inline="false"
        label-width="auto"
        :model="ruleForm" 
        :rules="rules"
        ref="ruleForm"
        >


          <el-form-item label="真实姓名:" prop="realName">
              <el-input v-model="ruleForm.realName"></el-input>
          </el-form-item>

          <el-form-item label="身份信息:" >
            <el-col :span="9">
              <el-form-item prop="idcodetype">
                <el-select v-model="ruleForm.idcodetype" placeholder="身份证" >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="15">
              <el-form-item prop="idcodevalue">
                <el-input v-model="ruleForm.idcodevalue"></el-input>
              </el-form-item> 
            </el-col> 
          </el-form-item>

          <!-- <el-form-item label="性别" prop="sex">
            <el-col :span="10">
              <el-radio v-model="ruleForm.sex" label="男">男</el-radio>
              <el-radio v-model="ruleForm.sex" label="女">女</el-radio>
            </el-col> 
          </el-form-item> -->

          <!-- <el-form-item label="家庭地址:">
          <el-row>
            <el-col :span="7">
              <el-form-item prop="Provincevalue">
                <el-select  clearable v-model="ruleForm.Provincevalue" placeholder="省" @change="provinceChange($event)" >
                  <el-option
                    v-for="item in form.provinceList"
                    :key="item.name"
                    :label="item.name"
                    :value="item.name">
                  </el-option>
                </el-select>
              </el-form-item>  
            </el-col>
            <el-col :span="2"></el-col>
            <el-col :span="7">

              <el-form-item prop="cityvalue">
                <el-select  clearable v-model="ruleForm.cityvalue" placeholder="市" @change="cityChange($event)" >
                  <el-option
                    v-for="item in form.cityList"
                    :key="item.name"
                    :label="item.name"
                    :value="item.name">
                  </el-option>
                </el-select>
              </el-form-item> 

            </el-col>
            <el-col :span="2"></el-col>
            <el-col :span="7">

              <el-form-item prop="countyvalue">
                <el-select clearable v-model="ruleForm.countyvalue" required placeholder="区">
                  <el-option
                    v-for="item in form.countyList"
                    :key="item.name"
                    :label="item.name"
                    :value="item.name">
                  </el-option>
                </el-select>
              </el-form-item>

            </el-col>
            </el-row>

            <el-row >
              <el-form-item prop="address">
                <el-input 
                v-model="ruleForm.address"
                placeholder="请填写详细地址">
                </el-input>
              </el-form-item>
            </el-row>   -->
      <!-- </el-form-item> -->

          <el-form-item>
            <el-button  @click="closeauth">关闭</el-button>
            <el-button  @click="submitForm('ruleForm')">确定</el-button>
          </el-form-item>
          
    </el-form>
      
    </div>
      
  </div>
</template>

<script>
import {mapGetters} from "vuex"
import request from '../utils/request';
export default {
  data() {
      // var validatemobile = (rule, value, callback) => {
      //     let str = /^[1][3,5,7,8][0-9]{9}$/
      //     if (value === '') {
      //       callback(new Error('请输入手机号'));
      //     } 
      //     if (str.test(value) == false) {
      //       callback(new Error('请输入正确的手机号')); 
      //     }
      //     else {
      //       callback();
      //     } 
      // };
      var validaterealName = (rule, value, callback) => {
        // let str = /^[a-zA-Z\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/ //用于校验“中英文”姓名
        let str = /[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,4}$/ //仅用于校验中文姓名
        if (value === '') {
            callback(new Error('请输入姓名'));
          }else if(str.test(value) == false){
            callback(new Error('请输入真实姓名'));
          }else if(value.length > 4){
            callback(new Error('请输入真实姓名'));  //仅用于校验中文姓名
          }
          else {
            callback();
          } 
      };
      var validateidcodevalue= (rule, value, callback) => {
        let str = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
        if (value === '') {
            callback(new Error('请输入身份证号码'));
          }else if(str.test(value) == false){
            callback(new Error('请输入正确的身份证号码'));
          }
          else {
            callback();
          } 
      }
      var validateaddress = (rule, value, callback) => {
        if (value === '') {
            callback(new Error('请输入详细地址'));
        } 
        else {
            callback();
        } 
      };
      return {
        ruleForm: {
          // mobile: '',
          realName:"",
          idcodetype:"", //发请求时 默认是1
          idcodevalue:"",
          // sex: '男' ,//单选框 男女 1男 0女
          Provincevalue: '', //省
          cityvalue: '', //市
          countyvalue: '', //区
          address: '', // 详细地址
        },
        rules: {
          // mobile: [
          //   { validator: validatemobile, trigger: 'blur' }
          // ],
          realName: [
            { validator: validaterealName, trigger: 'blur' }
          ],
          idcodevalue:[
            { validator: validateidcodevalue, trigger: 'blur' }
          ],
          // Provincevalue:[
          //   {required: true, message: '请选择省', trigger: 'blur'}
          // ],
          // cityvalue:[
          //   {required: true, message: '请选择市', trigger: 'blur'}
          // ],
          // countyvalue:[
          //   {required: true, message: '请选择区', trigger: 'blur'}
          // ],
          address: [
            {validator: validateaddress,trigger : 'blur',} 
          ],
        },
        // 身份证信息
        options: [{
            value: '1',
            label: '身份证'
          }, {
            value: '2',
            label: '港澳台身份证'
          }, 
        ],
        // 省市区
        form:{
          provinceList:[],
          cityList:[],
          countyList:[],
          },
          // 联动中转数组
          CITY:[],
          XIAN:[],
        
      }
  },
    created(){
      // 调用获取个人信息接口 根据登录成功返回的id 请求用户信息 用于回显表单数据
      // this.getpersoninfoall()
      // 调用获取 省级列表请求事件
      this.getprovincelist()
    },
    computed:{
      ...mapGetters([
        "personInfoid",//用户信息id
        "accountInfo",//账号信息（可获取手机号|账号）
      ])
    },
    methods:{
      closeauth(){
        // 关闭弹层  子传父 
          this.$emit("closeauth",false)
      },
      // 请求用户信息逻辑
      async getpersoninfoall(){
        const {data} =  await request({
          url:"/customer/PersonalUserInfo/getInfo",
          method:"POST",
          params:{
            personId : this.personInfoid  //vuex中的 登录时存储的信息id
          }
        })
        console.log("认证完成获取最新的用户信息成功")
        console.log(data.data)
        // 将数据存到vuex中(覆盖掉原来登录时存储的数据对象)
        this.$store.commit("updatepersonInfo",data.data || {} )
        // 数据回显(暂不需要进行数据回显 因为未认证状态下 是无数据的)
        // this.ruleForm.realName = data.data.realName
        // this.ruleForm.idcodevalue = data.data.realName
        // this.ruleForm.Provincevalue = data.data.realName
        // this.ruleForm.cityvalue = data.data.realName
        // this.ruleForm.countyvalue = data.data.realName
        // this.ruleForm.address = data.data.realName
        // this.ruleForm.sex = data.data.sex
      },
      // 表单提交逻辑
      submitForm(formName) {
          console.log("开始保存")
          
          this.$refs[formName].validate( async (valid) => {
            // if(this.ruleForm.Provincevalue === "" || this.ruleForm.cityvalue === "" || this.ruleForm.countyvalue === "" ){
            // // 如果未选择地址 则提示 并return出去 不去校验及请求
            // this.$alert('请完善地址信息',  {
            //   confirmButtonText: '确定',
            //   center:true,
            //   confirmButtonClass:"el-button--success",
            // });
              // this.$message({
              //   type: 'success',
              //   message: '请完善信息'
              // });
            // return
            // }
            console.log("开始校验")
            if (valid) {
              console.log("校验成功,发起请求")

              // 校验成功 发起请求 传送表单数据
            const {data} = await request({
                method:"POST",
                url: `/customer/PersonalUserInfo/modifyInfo`,
                params:{
                    id: this.personInfoid,                  
                    idCardNo: this.ruleForm.idcodevalue,
                    idCardType:1,
                    realName: this.ruleForm.realName,
                    // provinceName: this.ruleForm.Provincevalue,
                    // cityName: this.ruleForm.cityvalue,
                    // countyName: this.ruleForm.countyvalue,
                    // address: this.ruleForm.address,
                }
              })
              console.log(data)
              if(data.code == 200){
                // 提交请求成功
                await this.$alert('提交成功',  {
                    confirmButtonText: '确定',
                    center:true,
                    confirmButtonClass:"el-button--success",
                });
                // 将待认证按钮设为不显示 ↓
                // 使用id获取最新的用户信息 存入vuex（覆盖原数据 就实现了响应式的是否显示state状态）
                this.getpersoninfoall()
                // 关闭弹层 子传父
                this.$emit("closeauth",false)
              }else{
                await this.$alert('提交失败',  {
                    confirmButtonText: '确定',
                    center:true,
                    confirmButtonClass:"el-button--success",
                });
              }           
            } else {
              // 校验失败
              console.log("校验失败");
              return false;
            }
          });  
      },
      // 请求省级列表
      async getprovincelist(){
        await request({
              method:"get",
              url:"https://restapi.amap.com/v3/config/district?parameters",
              params:{
                  key:"3a708a4ef5e3af28694b1c861985a5ce",
                  keyWords:"中国",
                  subdistrict:3
              }
        }).then((res)=>{
            this.form.provinceList = res.data.districts[0].districts  /* 省*/
              /* 进行遍历赋值*/
              /* 市区和县区*/
            let newProvince = this.form.provinceList
            for(let i = 0; i < newProvince.length; i++){              /* 省级*/
                for(let j = 0; j < newProvince[i].districts.length; j++){       /* 市级*/
                    let city = newProvince[i].districts[j].name
                    this.CITY.push({id:j+1,name:city,code:i+1})
                    for(let k = 0;k<newProvince[i].districts[j].districts.length; k++){/* 县级*/
                        let xian = newProvince[i].districts[j].districts[k].name
                          this.XIAN.push({id:k+1,name:xian,code:j+1,cityCountyName:city})
                    }
                }
            }
            for(let m = 0; m < newProvince.length;m++){
                newProvince[m] = {...newProvince[m],...{code:m+1}}
            }
            this.form.provinceList = newProvince
            })
        },
        // 省级列表数据改变时触发
        provinceChange(that){
          // 清空市、区下拉框值
            this.ruleForm.cityvalue = ""
            this.ruleForm.countyvalue = ""
            // 根据选中省，匹配市
            let cityCode = 0
            let newCityArry = []
            this.form.provinceList.forEach((item,index)=>{
                if(item.name == that){
                    cityCode = item.code
                }
            })
              // console.log(cityCode)
            if(cityCode){
                this.form.cityList = []
                this.CITY.forEach((item,index)=>{
                    if(item.code == cityCode){
                        this.form.cityList.push(item)
                    }
                })  /* 市匹配成功*/
            }
          },
          // 市级列表数据改变时触发
          cityChange(that){
            this.ruleForm.countyvalue = ""
            
            let countyCode = 0
            let cityname = ''
            let newCountyArry = []
            this.form.cityList.forEach((item,index)=>{
                if(item.name == that){
                    countyCode = item.id
                    cityname = item.name
                }
            })
            if(countyCode){
                this.form.countyList = []
                this.XIAN.forEach((item,index)=>{
                    if(item.code == countyCode && item.cityCountyName == cityname){
                        this.form.countyList.push(item)
                    }
                })
            }
          },
    }
}
</script>

<style lang="less" scoped>
.personal h3 {
  font-size: 30px;
  text-align: left;
  margin-bottom: 33px;
}
/deep/.el-input__inner {
  background-color:#F1F0F6 ;
}
/deep/.el-form-item__label {
  font-size: 17px
}


/* el-单选框样式 */
  /* 单选框选中后的字体颜色 */
/deep/  .el-radio__input.is-checked + .el-radio__label {
    color: #333333 !important;
  }
  /* 单选框选中后小圆点的颜色 */
/deep/  .el-radio__input.is-checked .el-radio__inner {
    background: #16A34A !important;
    border-color: #16A34A !important;
  }

// 下拉框样式
/deep/ .el-row:first-child{
  margin-bottom: 5px;
  display: flex;
  justify-content: space-between;
}

/deep/ .el-button:first-child{
  margin-top: 15px;
  width: 100px;
  font-size: 20px;
  background-color:#F1F0F6;
  color:#333333;
  margin-left: -40px;
  margin-right:10px;
}
/deep/ .el-button:last-child{
   width: 100px;
  font-size: 20px;
  background-color:#16A34A;
  color:#FFFFFF;
}

</style>